import { inject, provide, ref, type InjectionKey, type Ref } from 'vue'

/**
 * Le conteneur qui scrolle réellement la page : `.app-main` dans `App.vue`
 * (`html { overflow: hidden }`, le scroll n'appartient jamais à `window`).
 * Tout composant qui doit réagir au défilement de la page — parallaxe, etc. —
 * passe par ce provide/inject plutôt que par `window` ou un `closest('.app-main')`.
 */
const key: InjectionKey<Ref<HTMLElement | null>> = Symbol('scrollContainer')

/** À appeler une fois, dans `App.vue`, avec le `ref` posé sur `.app-main`. */
export function provideScrollContainer(el: Ref<HTMLElement | null>): void {
  provide(key, el)
}

/** À appeler dans tout composant qui veut suivre le défilement de la page. */
export function useScrollContainer(): Ref<HTMLElement | null> {
  return inject(key, ref(null))
}
